import { handleResponse } from "./helpers";
import type { User, UserResponse } from "@/src/types/users";

const API_BASE_URL = import.meta.env.VITE_API_URL;
const CF_CLIENT_ID = import.meta.env.VITE_CF_CLIENT_ID;
const CF_CLIENT_SECRET = import.meta.env.VITE_CF_CLIENT_SECRET;

const getHeaders = (token: string) => {
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json',
    'CF-Access-Client-Id': `${CF_CLIENT_ID}`,
    'CF-Access-Client-Secret': `${CF_CLIENT_SECRET}`,
  }
}

export const getUser = async (userExternalId: string, accessToken: string): Promise<UserResponse> => {
  if (!userExternalId) {
    return { errors: [{ message: "User external ID is required" }] };
  }

  try {
    const response = await fetch(`${API_BASE_URL}/users?externalId=${userExternalId}`, {
      method: "GET",
      headers: getHeaders(accessToken),
    });

    return await handleResponse(response);
  } catch (error) {
    return { errors: [{ message: "An error occurred while fetching user" }] };
  }
};

export const createUser = async (userData: Partial<User>, accessToken: string): Promise<UserResponse> => {
  if (!userData) {
    return { errors: [{ message: "No user data provided" }] };
  }

  try {
    const response = await fetch(`${API_BASE_URL}/users`, {
      method: "POST",
      body: JSON.stringify(userData),
      headers: getHeaders(accessToken),
    });

    return await handleResponse(response);
  } catch (error) {
    return { errors: [{ message: "An error occurred while creating user" }] };
  }
};

export const updateUser = async (userData: Partial<User>, accessToken: string, id: number): Promise<UserResponse> => {
  if (!userData) {
    return { errors: [{ message: "No user data provided" }] };
  }

  try {
    const response = await fetch(`${API_BASE_URL}/users/${id}`, {
      method: "PATCH",
      body: JSON.stringify(userData),
      headers: getHeaders(accessToken),
    });

    return await handleResponse(response);
  } catch (error) {
    return { errors: [{ message: "An error occurred while updating user" }] };
  }
};
